import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=2881478e"
import script from "../../services/password/reset-password.js?vue&type=script&lang=js&external"
export * from "../../services/password/reset-password.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports